import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const MailboxesApi = {
  index(query) {
    return http.get(`${teamPath()}/mailboxes`, { params: query }).then((response) => response.data);
  },

  show(id) {
    return http.get(`${teamPath()}/mailboxes/${id}`).then((response) => response.data.data);
  },

  store(data) {
    return http.post(`${teamPath()}/mailboxes`, data).then((response) => response.data.data);
  },

  update(id, data) {
    return http.patch(`${teamPath()}/mailboxes/${id}`, data).then((response) => response.data.data);
  },

  destroy(id) {
    return http.delete(`${teamPath()}/mailboxes/${id}`).then((response) => response.data);
  },
};
